import React, { createContext, useContext, useState } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem('eturizam_user');
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  });

  const persist = (token, u) => {
    localStorage.setItem('eturizam_token', token);
    localStorage.setItem('eturizam_user', JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      persist(data.token, data.user);
      return { ok: true, user: data.user };
    } catch (err) {
      return { ok: false, error: err.response?.data?.detail || 'Greška pri prijavi. Pokušajte ponovo.' };
    }
  };

  const registerTourist = async (payload) => {
    try {
      const { data } = await api.post('/auth/register/tourist', payload);
      persist(data.token, data.user);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: err.response?.data?.detail || 'Greška pri registraciji.' };
    }
  };

  const registerSubject = async (payload) => {
    try {
      await api.post('/auth/register/subject', payload);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: err.response?.data?.detail || 'Greška pri registraciji.' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('eturizam_user');
    localStorage.removeItem('eturizam_token');
  };

  const hasPermission = (perm) => !!(user && user.permissions && user.permissions.includes(perm));

  return (
    <AuthContext.Provider value={{ user, login, logout, registerTourist, registerSubject, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
